/**
 * Postpaid mode (settings.prepaid === false) is intentionally disabled in the web admin.
 *
 * Postpaid logic remains elsewhere in the codebase for now, but it must not be enabled
 * from the web panel and should not be considered when designing new features until
 * this policy is explicitly reversed.
 */
export const POSTPAID_DISABLED_IN_WEB_ADMIN = true;
